export default __webpack_public_path__ + "static/world_map_white-d527a8dffceb3804d785eb29e537d58b.svg";